import { useEffect } from 'react'
import { useNavigate } from 'react-router'

export default function TournamentsIndex() {
	const navigate = useNavigate()

	useEffect(() => {
		const saved = sessionStorage.getItem('tournaments-last-tab')
		void navigate(saved ?? '/tournaments/results', { replace: true })
	}, [navigate])

	return null
}
